export function setupJobs() {
    const jobLists = document.querySelectorAll('.job-list');
    if (!jobLists.length) return;

    jobLists.forEach(jobList => {
        // Make sure the whole row is clickable, not just the title link
        jobList.addEventListener('click', e => {
            const row = e.target.closest('tbody tr');
            if (!row) return;
            if (e.target.closest('a')) return;

            const link = row.querySelector('.title-link');
            link?.click();
        });
    });
}
